module.exports = __webpack_public_path__ + "img/businesshours.e78a431f.png";